import AbstractComponent from "./abstract-component";

const createTemplate = (className = ``, count = 0) => {
  return (
    `<div class="${className}__counter counter">
      <button type="button" class="counter__button counter__button--delete" title="Удалить">–</button>
      <input class="counter__input" type="number" value="${count}" min="0" max="999" readonly>
      <button type="button" class="counter__button counter__button--add" title="Добавить">+</button>
    </div>`
  );
};


export default class CounterComponent extends AbstractComponent {
  constructor({className, count = ``}) {
    super();

    this._className = className;
    this._count = count;
  }

  set count(data) {
    this._count = data;
    this.getElement().querySelector(`.counter__input`).value = this._count;
  }

  getTemplate() {
    return createTemplate(this._className, this._count);
  }

  setAddButtonClickHandler(handler) {
    this.getElement().querySelector(`.counter__button--add`)
    .addEventListener(`click`, () => {
      handler(this._count + 1);
    });
  }

  setDeleteButtonClickHandler(handler) {
    this.getElement().querySelector(`.counter__button--delete`)
    .addEventListener(`click`, () => {
      if (this._count === 0) {
        return;
      }

      handler(this._count - 1);
    });
  }
}
